import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon, IconSize } from 'app/design-system/components/Icon';

import styles from './EntryComponents.module.scss';

// ---

type RemoveButtonProps = {
  disabled?: boolean;
  onClick: () => void;
  'data-test'?: string;
};

const RemoveButton: FC<RemoveButtonProps> = ({
  disabled = false,
  onClick,
  ...props
}) => {
  return (
    <button type="button"
            data-test={classNames(props['data-test'], 'removeButton-container')}
            disabled={disabled}
            className={styles.removeEntryButton}
            onClick={onClick}
            {...props}>
      <Icon icon="close-tiny"
            data-test="removeButton-icon"
            size={IconSize.SMALL} />
    </button>
  );
};

export default RemoveButton;
